export const uk = {
    'avg-click-cost': 'Ср. цена клика',
    'avg-click-cost-with-currency': 'Ср. цена клика, {currency}',
    'avg-cpm-cost': 'Ср. цена тыс. показов',
    'avg-cpm-cost-with-currency': 'Ср. цена тыс. показов, {currency}',
    'avg-goal-cost': 'Ср. цена конверсии',
    'avg-goal-cost-with-currency': 'Ср. цена конверсии, {currency}',
    avgClickCost: 'CPC',
    avgGoalCost: 'CPA',
    'bounce-rate-with-percent': 'Отказы, %',
    bounceRate: 'Отказы',
    clicks: 'Клики',
    conversionRate: 'Конверсии, %',
    cost: 'Расход',
    'cost-with-currency': 'Расход, {currency}',
    ctr: 'CTR',
    'ctr-with-percent': 'CTR, %',
    goals: 'Конверсии',
    profitability: 'ROI',
    'profitability-words': 'Ср. рентабельность инвестиций',
    revenue: 'Доход',
    'revenue-with-currency': 'Доход, {currency}',
    shows: 'Показы'
};
